import userApi from '../../request/userApi';

const state = {
  OpenId: '',
  IsLogin: false,
  SessionKey: '',
  BusinessId: 0,
  UserData: {},
  Location: '', // 用户定位
}

// 以计算属性形式返回
const getters = {

}

// 异步获取值后commit mutations更改值
const actions = {
  wechatLogin({
    commit,
    state
  }, data) {
    userApi.weixinLogin(data.code, 2).then(sucRes => {
      let result = sucRes;
      if (result.success) {
        commit('setH5LoginInfo', {
          openid: result.data.openid
        });
        let save = data.context.$cookies.set("OpenID", result.data.openid, '8D', '/wechat');
        console.log('save=>', save);
        data.context.$store.dispatch('user/getUserData');
        data.context.$store.dispatch('ticket/getDefaultAddress', result.data.openid);
        return true;
      } else {
        return false;
      }
    });
  },
  getUserData({
    commit,
    state
  }) {
    if (state.IsLogin) {
      userApi.getUserData(state.OpenId).then(sucRes => {
        let result = sucRes;
        if (result.success) {
          commit('setUserData', result.data);
          return true;
        } else {
          return false;
        }
      });
    }
  }
}

// 更改值
const mutations = {
  setWxLoginInfo(state, loginInfo) {
    state.OpenId = loginInfo.openid;
    state.IsLogin = true;
    state.SessionKey = loginInfo.session_key;
  },
  setH5LoginInfo(state, loginInfo) {
    state.OpenId = loginInfo.openid;
    state.IsLogin = true;
  },
  setTicketMode(state) {
    state.BusinessId = 1;
  },
  setScopeMode(state) {
    state.BusinessId = 2;
  },
  setUserData(state, userInfo) {
    state.UserData = userInfo;
  },
  setLocation(state, location) {
    state.Location = location;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js